import api from './axiosClient';

export const swrFetcher = (url) => api.get(url).then((res) => res.data);
